import { render, staticRenderFns } from "./saticilar.vue?vue&type=template&id=de15bb7c&"
import script from "./saticilar.vue?vue&type=script&lang=js&"
export * from "./saticilar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports